import React from 'react';
import styles from './NotebookViewer.module.css';

interface NotebookViewerProps {
  src: string;
  onClose: () => void;
}

const NotebookViewer: React.FC<NotebookViewerProps> = ({ src, onClose }) => (
  <div className={styles.viewer}>
    <div className={styles.frameWrapper}>
      <div className={styles.frameInner}>
        <button className={styles.backBtn} onClick={onClose}>
          ← Back
        </button>
        <iframe
          className={styles.frame}
          src={src}
          title="Notebook"
        />
      </div>
    </div>
  </div>
);

export default NotebookViewer;
